/**
 * The words of the site type screens (piece 10, piece 13, piece 15; decision 10100; T3476): Settings › Organization ›
 * Site Types, the Site window's select and the Sites list's segments, spread into the one string lookup.
 */
export const SITE_TYPE_STRINGS = {
  'settings.siteTypes.title': 'Site Types',
  'settings.siteTypes.hint': 'The kinds of place a site can be. A site picks one on + Add Site and on its Edit form. A retired type leaves the picker and stays on every site that carries it.',
  'settings.siteTypes.add': '+ Add Site Type',
  'settings.siteTypes.addTitle': 'Add Site Type',
  'settings.siteTypes.name': 'Name',
  'settings.siteTypes.notes': 'Notes',
  'settings.siteTypes.noNotes': 'No notes',
  'settings.siteTypes.retired': 'Retired',
  'settings.siteTypes.carriedOne': 'On 1 site',
  'settings.siteTypes.carried': 'On {count} sites',
  'settings.siteTypes.retire': 'Retire',
  'settings.siteTypes.restore': 'Restore',
  'settings.siteTypes.delete': 'Delete',
  'settings.siteTypes.moveUp': 'Move up',
  'settings.siteTypes.moveDown': 'Move down',
  'settings.siteTypes.first': 'Already first in the list.',
  'settings.siteTypes.last': 'Already last in the list.',
  'settings.siteTypes.deleteTitle': 'Delete Site Type',
  'settings.siteTypes.deleteConsequence': '{name} leaves the list for good. No site carries it, so no site changes.',
  'settings.siteTypes.none': 'No site type yet. Add the first with + Add Site Type.',
  'siteModal.siteType': 'Site type',
  /** 🔒 Decision 10500: what the field's footer adds, read as Add New Site Type. */
  'siteModal.siteTypeEntity': 'Site Type',
  'list.segments.all': 'All',
} as const;
